import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { setNotificationCount, setNotificationLoad, settNotifications, setUserProfile } from '../../Global/globalSlice';
// import { unauthorizedError } from '../../../utils/helpers';
import organizationInfoService from '../../../services/api/Organization/organizationInfoService';
import _axios from '../../../services/api';
import { API_ROUTES } from '../../../utils/constants';


const organizationData = new organizationInfoService();

export const get_all_Subscriptions_org = createAsyncThunk(
    "organizationData/get_all_Subscriptions_org",
    async ({ navigate }, { dispatch }) => {
        try {
            const response = await organizationData.Get_all_subscriptions()
            dispatch(setAllSubscriptionorg(response.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.message && message.error(error?.response?.data?.message)
            // }
        }
    }
);

export const get_latest_Subscriptions_org = createAsyncThunk(
    "organizationData/get_latest_Subscriptions_org",
    async ({ navigate }, { dispatch }) => {
        try {
            const response = await organizationData.Get_latest_subscriptions()
            dispatch(setLatestSubscriptionsorg(response.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.message && message.error(error?.response?.data?.message)
            // }
        }
    }
);

export const get_all_skills_data = createAsyncThunk(
    "organizationData/get_all_skills_data",
    async ({ navigate }, { dispatch }) => {
        try {
            const response = await organizationData.Get_All_Skills_Data()
            dispatch(setAllSkills(response.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.message && message.error(error?.response?.data?.message)
            // }
        }
    }
);

export const get_notifications = createAsyncThunk(
    "organizationData/get_notifications",
    async ({ navigate }, { dispatch }) => {
        dispatch(setNotificationLoad(true))
        try {
            const { data } = await _axios.get(API_ROUTES.ORGANIZATION.NOTIFICATIONS);
            dispatch(settNotifications(data?.data))
            dispatch(setNotificationCount(data?.notification))
            dispatch(setNotificationLoad(false))
        } catch (error) {
            // if (error?.response && [401, 403, 419, 440].includes(error.response.status)) {
            //     dispatch(setUserProfile({}));
            //     unauthorizedError(navigate);
            // }
        } finally {
            dispatch(setNotificationLoad(false))
        }
    }
);

const initialState = {
    allSubscriptionsorg: [],
    latestSubscriptionsorg: [],
    selectedRolePermisionsData: {},
    isPermissionsModal: false,
    isCreateRoleModal: false,
    isEditRoleModal: false,
    selectedEditData: {},
    isManageUserModal: false,
    all_skills: [],
    InterviewData: {},
    tokensList: [],
    tokensRedux: [],
};

const organizationDataSlice = createSlice({
    name: 'organizationData',
    initialState,
    reducers: {
        setAllSubscriptionorg: (state, action) => {
            state.allSubscriptionsorg = action.payload
        },
        setLatestSubscriptionsorg: (state, action) => {
            state.latestSubscriptionsorg = action.payload
        },
        setSelectedRolePermissionsData: (state, action) => {
            state.selectedRolePermisionsData = action.payload
        },
        setIsPermissionModal: (state, action) => {
            state.isPermissionsModal = action.payload
        },
        setIsCreateRoleModal: (state, action) => {
            state.isCreateRoleModal = action.payload
        },
        setIsEditRoleModal: (state, action) => {
            state.isEditRoleModal = action.payload
        },
        setSelectedEditData: (state, action) => {
            state.selectedEditData = action.payload
        },
        setIsManageUserModal: (state, action) => {
            state.isManageUserModal = action.payload
        },
        setAllSkills: (state, action) => {
            state.all_skills = action.payload
        },
        setInterviewData: (state, action) => {
            state.InterviewData = action.payload
        },
        setTokensList: (state, action) => {
            state.tokensList = action.payload
        },
        setTokenRedux: (state, action) => {
            state.tokensRedux = action.payload
        }

    }
});

export const
    { setAllSubscriptionorg, setLatestSubscriptionsorg, setSelectedRolePermissionsData, setIsPermissionModal,
        setIsCreateRoleModal, setIsEditRoleModal, setSelectedEditData, setIsManageUserModal, setAllSkills,
        setInterviewData, setTokensList } = organizationDataSlice.actions;
export default organizationDataSlice.reducer;
